import math from "mathjs";

/**
 *
 * @param data
 * @param lags
 * @param first
 * @param start
 * @returns {*}
 */
export function get_factors_w_lags(data, lags, offset) {
    return range(data.length - offset, offset).map((idx) => {
        let row = [];
        for(let i = 0; i<4; i++)
            row.push(lags[i].map((lag) => data[idx - lag][i + 4]));
        return flatten(row);
    });
}

/*
The same functionality as row.flat(). The latter does not work in all browsers, so we implement our own version.
 */
export function flatten(array){
    return [].concat.apply([], array);
}

export function range(size, startAt = 0) {
    return [...Array(size).keys()].map(i => i + startAt);
}
/**
 * @param observations: array of weights, length n + 1
 * @param predictions: array of datapoints, length n
 * @return coefficient of determination
 * Note that there exists different formulas for the coefficient.
 */
export function r_squared(observations, predictions) {
    const sum = observations.reduce(
        (accumulator, observation) => accumulator + observation, 0);
    const mean = sum / observations.length;

    const ssregr = predictions.reduce(
        (accumulator, prediction) => accumulator + Math.pow(prediction - mean, 2), 0);

    const ssres = observations.reduce(
        (accumulator, observation, idx) => accumulator + Math.pow(observation - predictions[idx], 2), 0);

    return ssregr / (ssregr + ssres);
}

/**
 *
 * @param actual observations of temperatures
 * @param best_fit predictions of temperatures
 * @param predictions adjusted predictions
 * @returns {number} reflects the deviation of "predictions" from the those of "best-fit"
 */
export function progress_value(actual, best_fit, predictions){
    let col1 = best_fit.map((temp, idx) => math.abs(temp - predictions[idx]));
    let col2 = best_fit.map((temp) => math.abs(temp - math.mean(actual)));
    return r_squared(actual, best_fit)*(1 - math.sum(col1)/math.sum(col2));
}

/**
 *
 * @param weights      list of weights, intercept of the model e.g. [e1, e2, e3, v1, v2, s1, a1, b0]
 * @param amplitudes   the amplitudes to multiply weights by e.g. [1, 1, 0, 1]
 * @param n_of_factors list that specifies how many factors of each forcing is present in the model e.g. [3, 2, 1, 1]
 */
export function scaled_weights(weights, f1, f2, f3, f4) {
    return weights.map((weight, idx) => {
        if (idx < 3)
            return [f1 * weight];
        else if (idx < 5)
            return [f2 * weight];
        else if (idx < 6)
            return [f3 * weight];
        else if (idx < 7)
            return [f4 * weight];
        else
            return [1 * weight];
    });
}

/**
 * @param weights: array of weights, length n + 1
 * @param data: array of datapoints, length n
 * @return [data, 1] <dot product> coefs
 */
export function predict(weights, data) {
    return data.map(
        (datapoint) => datapoint.reduce(
            (accumulator, value, idx) => accumulator + value * weights[idx], +weights[weights.length - 1]));
}


/**
 * Retrieves the mean and std dev for each column EXCEPT FOR THE FIRST (which is time)
 * @param data
 * @returns {Array} [[<mean temp column>, <std dev temp column>], ..., [<mean column anth column>, <std dev column anth column>]]
 */
export function get_stats(data){
    let stats = [];
    for(let i = 0; i<data[0].length; i++){
        let mean = math.mean(data.map((datapoint) => datapoint[i]));
        let std = math.std(data.map((datapoint) => datapoint[i]));
        stats.push([mean, std])
    }
    return stats;

}

/**
 * @param data
 * @param stats [[<mean temp column>, <std dev temp column>], ..., [<mean column anth column>, <std dev column anth column>]]
 * @returns {Array} matrix where each column EXCEPT FOR THE FIRST (which is time) is normalized
 */
export function normalized(data){
    let normalized_data = [];
    let stats = get_stats(data);
    for(let i = 0; i<data.length; i++){
        normalized_data.push(data[i].map((feature, idx) => (feature - stats[idx][0])/stats[idx][1]));
    }
    return normalized_data;
}
